<p>merge-field-settings works!</p>
